import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import CommentEditPriceModalContent from './CommentEditPriceModalContent/CommentEditPriceModalContent';

interface ICommentsModalProps {
    handleCloseModal: () => void;
    isSaving: boolean;
}

const CommentsModal = ({ handleCloseModal, isSaving }: ICommentsModalProps) => {

  return (
    <NudosGenericModal
      modalContent={
        <NudosModalContent
          modalContentTitle="Comentarios sobre la edición de precios"
          hideNudosIcon
          customWidth='580px'
          customHeight='426px'
          toCloseModal={handleCloseModal}
          CustomModalComponent={<CommentEditPriceModalContent isSaving={isSaving} />}
        />
      }
    />
  );
};

export default CommentsModal;
